// removed by extract-text-webpack-plugin
module.exports = {"btn":"button__btn___3oes_","btnFocusable":"button__btn--focusable___27KGe","btnPrimary":"button__btn--primary___2WJGm","btnFlat":"button__btn--flat___24hTp","btnIcon":"button__btn--icon___hoKye"};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/button/button.scss
// module id = 194
// module chunks = 0 1